import { createSelector } from 'reselect';

const getState = (state) => state.app;

// eslint-disable-next-line import/prefer-default-export
export const getLoading = createSelector(getState, (state) => state.loading);
export const getCurrentRoute = createSelector(getState, (state) => state.currentRoute);
